import Errors from "../../utils/errors";

export default function ErrorContainer({ errors = [], children, fill, style = {}, className = '' }) {
    return (
        <div className={`error-container ${className}`} style={{ width: fill ? '100%' : 'inherit', ...style }}>
            { children }
            { errors && errors.length > 0 && <div class="error-container__errors">{ errors.map(err => {
                const error = Errors?.[err] || err;

                return <p dangerouslySetInnerHTML={{ __html: error }}></p>
            }) }</div> }
        </div>
    )
}